<template>
  <div class="edit-org-name-box">
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item>
        <div class="cube-form-tip-box">
          <h3>{{ $t('message["1589"]') }}  {{ this.$route.query.comname }}</h3>
          <p> {{ $t('message["1642"]') }}。</p>
        </div>
      </cube-form-item>
      <cube-form-item :field="fields[0]">
        <tranfer-user @getActive="getItem" />
      </cube-form-item>
      <template v-if="!$isDingDing">
        <cube-form-item
          :field="fields[1]"
          style="margin-left: -6px;"
        />
        <div class="cube-form-item-box valid-code-item">
          <cube-form-item :field="fields[2]" />
          <div class="find-pwd-box">
            <get-code
              class="find-pwd-link"
              :mobile="newMobile"
              type="14"
              :is-disabled="false"
            />
          </div>
        </div>
      </template>
      <div class="btn-sub">
        <cube-button
          v-if="!$isDingDing"
          type="submit"
          :primary="true"
        >
          {{ $t('message["1641"]') }}
        </cube-button>
        <cube-button
          v-else
          type="submit"
          :primary="true"
          @click="submitHandler"
        >
          转让
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import GetCode from '@/components/mobile/GetCode'
import TranferUser from './TranferUser'
export default {
  components: {
    GetCode,
    TranferUser
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      newMobile: '',
      model: {
        transferuserid: '',
        mobile: '',
        checkcode: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'transferuserid',
          label: this.$t('message["1121"]'),
          props: {
            placeholder: ''
          },
          rules: {
            // required: true
          }
        },
        {
          type: 'input',
          modelKey: 'mobile',
          label: this.$t('message["1112"]'),
          props: {
            placeholder: '',
            disabled: true
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('organization/org', ['orgSelectDatas'])
  },
  async mounted () {
    const chain = await this.fetchOrgSelectDatas()
    chain.params({ cid: this.$route.query.cid })
      .onSuccess(() => {
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchOrgSelectDatas', 'ajaxSecondTranOrg']),
    async submitHandler (e) {
      let obj = {}
      const chain = await this.ajaxSecondTranOrg()
      if (!this.$isDingDing) {
        this.model.mobile = this.newMobile
      }
      obj = Object.assign(this.model, { cid: this.$route.query.cid })
      chain.params(obj)
        .onSuccess(raw => {
          this.$router.push({
            name: 'OrgIndex',
            query: {
              page: 1
            } })
        })
        .onNetSuccess((res) => {
          // const toast = this.$createToast({
          //   time: 2000,
          //   txt: res.data.message || res.data.payload[0].message,
          //   type: 'txt'
          // })
          // toast.show()
          const error = res.data.error
          if (!error) {
            this.$selefToast({ text: res.data.message })
          } else {
            this.$selefToast({ type: 'error', text: res.data.message || res.data.payload[0].message })
          }
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({
        name: 'OrgIndex',
        query: {
          page: 1
        } })
    },
    getItem (item) {
      this.model.transferuserid = item.userid
      if (!this.$isDingDing) {
        this.model.mobile = item.mobile
        this.newMobile = item.newMobile
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-sub {
  padding: 60px 12px;
}
.valid-code-item::v-deep {
    .cube-form-item {
       padding-left: 115px;
    }
  }
  .edit-org-name-box::v-deep {
    .cube-form-item {
      min-height: 56px;
      line-height: 56px;
      .cube-form-label {
        color: #888;
      }
    }
    .cube-form-item-box .find-pwd-box {
      top: 16px;
    }
  }
</style>
